import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'
import { DataDatasetProvider } from './datasets'

const DataDashboardPage = lazyWithRetry(() => import('./pages/DataDashboardPage'))
const DataPromptsPage = lazyWithRetry(() => import('./pages/DataPromptsPage'))
const DataResponsesPage = lazyWithRetry(() => import('./pages/DataResponsesPage'))
const DataSourcesPage = lazyWithRetry(() => import('./pages/DataSourcesPage'))
const DataActionsPage = lazyWithRetry(() => import('./pages/DataActionsPage'))

const routes: AppRoute[] = [
  {
    path: 'data',
    layout: DataDatasetProvider,
    children: [
      {
        path: 'dashboard',
        element: DataDashboardPage,
        meta: {
          title: 'data.dashboard.title',
          require: { minRole: ROLE.VIEWER },
        },
      },
      {
        path: 'prompts',
        element: DataPromptsPage,
        meta: {
          title: 'data.prompts.title',
          require: { minRole: ROLE.VIEWER },
        },
      },
      {
        path: 'prompts/responses',
        element: DataResponsesPage,
        meta: {
          title: 'data.responses.title',
          require: { minRole: ROLE.VIEWER },
        },
      },
      {
        path: 'sources',
        element: DataSourcesPage,
        meta: {
          title: 'data.sources.title',
          require: { minRole: ROLE.VIEWER },
        },
      },
      {
        path: 'actions',
        element: DataActionsPage,
        meta: {
          title: 'data.actions.title',
          require: { minRole: ROLE.VIEWER },
        },
      },
    ],
  },
]

export default routes
